// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","overlay":"Modal_overlay__r63M6"};